import React, { Component } from "react"
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Player } from "@lottiefiles/react-lottie-player"

// import ld_tracking_delivery_01 from '../../../assets/ld_tracking_delivery_01.json';
// import ld_tracking_delivery_02 from '../../../assets/ld_tracking_delivery_02.json';
class UILoadingAnim extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
    
            anim_list: [
                // {
                //     id: 1,
                //     file: ld_tracking_delivery_01
                // },
                // {
                //     id: 2,
                //     file: ld_tracking_delivery_02
                // },
                {
                    id: 3,
                    file: 'https://lottie.host/9207c1b4-5242-4ec9-9fe2-ef9a912b4f4b/ntzk76ALEC.json'
                },
                {
                    id: 4,
                    file: 'https://assets3.lottiefiles.com/packages/lf20_UJNc2t.json'
                },
                {
                    id: 5,
                    file: 'https://lottie.host/cb365ff3-3b53-4312-8647-173c6621ae8d/DcMdHrNHeA.json'
                },
                {
                    id: 6,
                    file: 'https://lottie.host/d318f5c7-622b-433e-a4f6-264ea6e5e0c2/fh5X11276x.json'
                },
                {
                    id: 7,
                    file: 'https://lottie.host/43fd1dd4-5dac-480c-8b50-60eb597dcad9/NOYV6v1WTf.json'
                }
            ]
        }
    }

    render() {
    
        const uiLoading = this.props.uiLoading || 3 ;
        const file = this.state.anim_list[uiLoading].file
      
        return (
            /*
            style={{
                height: 200,
                width: 500,
                position: 'absolute',
                top: this.props.opening ? '40%' : '30%',
                right: 0,
                left: 0,
                margin: 'auto',
                display: 'block',
                backgroundColor: '#FFFFFF  !important',
                transform: 'translate(0, -50%)',

            }}
            */
            <div className="text-light loading">
                <div className="background"></div>
                <Player
                    //src={this.state.anim_list[this.props.url_anim]}
                    src={this.state.anim_list[uiLoading].file}
                    className="player"
                    loop
                    autoplay
                />
            </div>
        )
    }
}

UILoadingAnim.PropTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
    refresh: PropTypes.any,
    url_anim: PropTypes.any,
    opening: PropTypes.any,
    uiLoading:  PropTypes.any,
}

const mapStateToProps = state => {
    return {}
}

export default withTranslation()(withRouter(connect(mapStateToProps, {})(
    (UILoadingAnim)
)))

